import {consequence} from './state';

export function setMatrix(state, matrix) {
    state.matrix = matrix;
}

export function setCompanies(state, companies) {
    state.companies = companies;
}

export function setConsequence(state, consequence) {
    state.consequence = consequence;
}

export function setLoadingCompanies(state, loading_companies) {
    state.loading_companies = loading_companies;
}

export function setCompanyIdFilter(state, company_id) {
    state.filters.company_id = company_id;
}

export function setIncrementalProbabilites(state, incremental_probabilities) {

    incremental_probabilities.map(ip => {
        ip.click = false;
        ip.consequence_severities.map(cs => cs.click = false);
    });

    state.incremental_probabilities = incremental_probabilities;
}

export function setModalShow(state, modal) {
    state.modal.show = modal;
}

export function resetConsequence(state) {
    state.consequence = consequence();
}

export function setAction(state, action) {
    state.action = action;
}

export function setCompanyIdConsequence(state, company_id) {
    state.consequence.company_id = company_id;
}

